import entities from 'src/config/entities';
import BaseService from "./BaseService";
import axios from 'axios'
class ClientService extends BaseService {
  constructor() {
    super({ entity: entities.CLIENT });
  }

  getClientUsers(params, path) {
    return super.get(params, path);
  }

  async getKpi(clientUuid, range = 'today') {
    try {
      return await axios.get(`clients/${clientUuid}/kpi`, {
        params: {
          date_range: range
        }
      });
    } catch (e) {
      this._handleError({ translationKey: 'generic.get.error', error: e });
      throw e;
    }
  }

  async inviteUser(clientId, data) {
    try {
      let result = await axios.post(`clients/${clientId}/invite`, data);
      this._handleSuccess({ translationKey: 'user.create.success' })
      return result;
    } catch(e) {
      this._handleError({ translationKey: 'user.create.error', error: e })
      return null;
    }
  }

  getClientCredits(clientId) {
    return axios.get(`clients/${clientId}/credits-balance`)
  }

  getClientContracts(params, path) {
    let url = path || `clients/${params.clientId}/contracts`
    return axios.get(url, params)
  }

  getClientContractsBalance(clientId) {
    return axios.get(`clients/${clientId}/contracts-balance`)
  }

  async verify(clientId, data) {
    try {
      return await axios.put(`clients/${clientId}/verify`, data)
    } catch (e) {
      this._handleError({ translationKey: 'generic.get.error', error: e });
      throw e;
    }
  }

  async createOrder(clientId, productId, data) {
    try {
      return await axios.post(`clients/${clientId}/order/${productId}`, data)
    } catch (e) {
      this._handleError({ translationKey: 'generic.createOrderError', error: e });
      throw e;
    }
  }

  mergeClient(orgId, data) {
    return this.instance.put(`${orgId}/merge`, data);
  }

  async updateFinancialAddress(client, newAddress) {
    if (client.addresses) {
      let index = client.addresses.findIndex(address => address.financial)
      if (index === -1) {
        client.addresses.push({
          ...newAddress,
          financial: 1
        })
      } else {
        client.addresses[index] = newAddress
      }
    } else {
      client.addresses = [({
        ...newAddress,
        financial: 1
      })]
    }
    await this.update(client.uuid, client)
  }
}

export default new ClientService();
